export const openRouterDefaultsV1015 = () => ({
  enabled: false,
  mode: 'floor',
  require_parameters: true,
  allow_fallbacks: true,
  max_price: {},
});

export const openRouterConfigV1015 = (config = {}) => ({
  ...openRouterDefaultsV1015(),
  ...config.openrouter_v1015,
  max_price: { ...config.openrouter_v1015?.max_price },
});

export function buildOpenRouterSubmissionV1015(config, type) {
  if (Number(type) !== 20)
    return Object.prototype.hasOwnProperty.call(config, 'openrouter_v1015')
      ? { ...config, openrouter_v1015: null }
      : { ...config };
  if (config.openrouter_v1015 == null) return { ...config };
  const policy = openRouterConfigV1015(config);
  if (!['default', 'price', 'floor'].includes(policy.mode) ||
      ['enabled', 'require_parameters', 'allow_fallbacks'].some(
        (key) => typeof policy[key] !== 'boolean'
      ))
    throw new Error('channel.edit.openrouter_v1015.invalid');
  const maxPrice = {};
  for (const [key, raw] of Object.entries(policy.max_price)) {
    const value = String(raw).trim();
    if (value === '') continue;
    if (!['prompt', 'completion', 'request', 'image'].includes(key) ||
        !/^(0|[1-9][0-9]{0,11})(\.[0-9]{1,18})?$/.test(value))
      throw new Error('channel.edit.openrouter_v1015.invalid');
    maxPrice[key] = value;
  }
  return {
    ...config,
    openrouter_v1015: { ...policy, max_price: maxPrice },
  };
}
